// application-insights.service.ts
import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from '../../environments/environment';
import { ApplicationInsightModel } from '../models/application-insight-class';

@Injectable({
  providedIn: 'root'
})
export class ApplicationInsightService {
  private appInsights: ApplicationInsights;

  constructor() {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: environment.appInsights.instrumentationKey,
        autoTrackPageVisitTime: true,
        appId: environment.appId,
        disableAjaxTracking: true,
      },
    });

    this.appInsights.loadAppInsights();
  }

  trackPageView(name: string): void {
    this.appInsights.trackPageView({ name });
  }


  setUserAuthProfile(userAuthProfile: ApplicationInsightModel): void {
    if (!userAuthProfile || !userAuthProfile.UserName || userAuthProfile.UserName.trim().length === 0)
      return;

    this.appInsights.setAuthenticatedUserContext(userAuthProfile.UserFullName, userAuthProfile.UserName, true);

    this.appInsights.addTelemetryInitializer((telemetryItem) => {
      const baseData = telemetryItem.baseData || {};
      baseData.properties = baseData.properties || {};
      baseData.properties["AppName"] = 'AmSuite';
      baseData.properties["AuthType"] = userAuthProfile.AuthType ?? "asp";
      baseData.properties["AuthDomain"] = userAuthProfile.AuthDomain ?? null;
      baseData.properties["DataOwnerId"] = userAuthProfile.DataOwnerId;
      baseData.properties["ImpersonateState"] = userAuthProfile.ImpersonateState && userAuthProfile.ImpersonateState.trim().length > 0 ? userAuthProfile.ImpersonateState : 'false';

      if (!telemetryItem.tags)
        telemetryItem.tags = {} as any;

      // Imposta lo user_Id e user_AuthenticatedId
      telemetryItem.tags["ai.user.id"] = userAuthProfile.UserFullName;
      telemetryItem.tags["ai.user.authUserId"] = userAuthProfile.UserName;
    });
  }

  clearUserId(): void {
    this.appInsights.clearAuthenticatedUserContext();
  }

  logException(exception: Error, severityLevel?: number) {
    this.appInsights.trackException({ exception: exception, severityLevel: severityLevel });
  }
}
